import jQuery from "jquery";

// Set to true to prevent console output; migrateWarnings still maintained
jQuery.migrateMute = true;
